import CloseIcon from '~shared/assets/icons/close.svg?react';

import { IconButton } from '@breezeventures/ui-kit/icon-button';

import {
  BusinessSelect,
  StatusSelect,
  StoreSelect,
} from './orders-filter-fields';

type Props = {
  onFiltersChange: () => void;
  onReset: () => void;
};

export function OrdersFilters({ onFiltersChange, onReset }: Props) {
  return (
    <div
      className={`
        grid grid-cols-[repeat(3,minmax(180px,1fr))_auto] items-center gap-2
      `}
    >
      <BusinessSelect onChange={onFiltersChange} />
      <StoreSelect onChange={onFiltersChange} />
      <StatusSelect onChange={onFiltersChange} />

      <IconButton
        type="button"
        variant="secondary"
        size="l"
        aria-label="Reset filters"
        onClick={onReset}
      >
        <CloseIcon className="size-3.5!" />
      </IconButton>
    </div>
  );
}
